import { PageComponent } from "./page.component";
import { State } from "../../store/reducers";
import { connect } from "react-redux";
import { deviceDirectoryRequestStartAction } from "../../store/Device/DeviceAction";
import { runCommandStartAction } from "../../store/Command/CommandAction";
import { templateDirectoryRequestStartAction } from "../../store/Template/TemplateAction";

const mapStateToProps = (state: State) => ({
  commandRunning: state.command.loading,
  templateDirLoading: state.template.directory.loading,
  deviceDirLoading: state.device.directory.loading,
  deviceDirectory: state.device.directory.items,
  templateDirectory: state.template.directory.items,
});

const mapDispatchToProps = (dispatch: any) => ({
  runCommandStartAction: (
    outVersion: number,
    deviceId: number,
    params: string
  ) => dispatch(runCommandStartAction(outVersion, deviceId, params)),
  onRequestDeviceDirectory: () => dispatch(deviceDirectoryRequestStartAction()),
  onRequestTemplateDirectory: () =>
    dispatch(templateDirectoryRequestStartAction()),
});

export const PageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PageComponent);
